import React from "react";
import "../supplier-info.scss";
import { useTranslation } from "react-i18next";
import InfoSection from "./InfoSection";
import { useSelector } from "react-redux";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import { formatCurrencyToLocale } from "../../../../utils/method";
import InfoRow from "./InfoRow";

const ContractSecuritySection = () => {
    const { t } = useTranslation();

    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts, invoice } = supplierInfo || { amounts: {}, invoice: {} };

    const isFinalInvoice = invoice?.isFinalInvoice;
    const securityLabel = isFinalInvoice ? "supplier-info.warranty-bonds" : "supplier-info.contract-security";
    const securityAmount = isFinalInvoice ? (amounts?.performanceBonds || 0) : (amounts?.contractFulfilmentGuarantees || 0);
    const availabilityStatus = securityAmount > 0 ? "supplier-info.available" : "supplier-info.not-available";

    return (
        <InfoSection>
            <div
                className="p-2 css-security-highlight"
            >
                <InfoRow
                    label={t(securityLabel)}
                    value={`${formatCurrencyToLocale(securityAmount)} ${t(availabilityStatus)}`}
                    equalColumns
                />
            </div>
            <div className="text-end text-danger small">
                <i>{t("supplier-info.from-capmo")}</i>
            </div>
        </InfoSection>
    );
};

export default ContractSecuritySection;
